// Сезонная тема оформления. Какая тема сейчас — решает сервер переменной
// SEASON_THEME (в Infisical; меняется перезапуском сервера, без пересборки
// фронта), пользователь только включает/выключает её кнопкой в шапке.
//
//   пусто / cat  → кошко-девочки (обычная тема)
//   halloween    → Хэллоуин
//
// Новая тема (например, новогодняя): компоненты по образцу Cat*/Halloween*,
// css с правилами под своим appClass, запись в SEASON_THEMES, модификатор
// .rd-theme-toggle--<id> в header.css — и SEASON_THEME=<id> в Infisical.

import { useEffect, useState } from 'react';
import CatThemeOverlay from '../components/CatThemeOverlay';
import CatDecorations from '../components/CatDecorations';
import CatLoader from '../components/CatLoader';
import HalloweenThemeOverlay from '../components/HalloweenThemeOverlay';
import HalloweenDecorations from '../components/HalloweenDecorations';

export const SEASON_THEMES = {
    cat: {
        id: 'cat',
        appClass: 'app-catgirl',
        bodyClass: 'cat-theme',
        icon: '🐱',
        titleOn: 'Позвать Мурку (режим кошко-девочек)',
        titleOff: 'Выключить Мурку (режим кошко-девочек)',
        Overlay: CatThemeOverlay,
        Decorations: CatDecorations,
        Loader: CatLoader,
    },
    halloween: {
        id: 'halloween',
        appClass: 'app-halloween',
        bodyClass: 'halloween-theme',
        icon: '🎃',
        titleOn: 'Включить режим Хэллоуина',
        titleOff: 'Выключить режим Хэллоуина',
        Overlay: HalloweenThemeOverlay,
        Decorations: HalloweenDecorations,
        Loader: null,
    },
};

const DEFAULT_THEME_ID = 'cat';
// Последняя тема, которую назвал сервер, — чтобы при загрузке страницы
// сразу показать её, а не мигнуть кошками до ответа сервера.
const THEME_ID_STORAGE_KEY = 'seasonThemeId';

function themeById(id) {
    return SEASON_THEMES[id] || SEASON_THEMES[DEFAULT_THEME_ID];
}

export function readCachedSeasonTheme() {
    try {
        return themeById(localStorage.getItem(THEME_ID_STORAGE_KEY));
    } catch {
        return SEASON_THEMES[DEFAULT_THEME_ID];
    }
}

// Тема сезона: сразу — из кэша, затем — как скажет сервер.
export function useSeasonTheme() {
    const [theme, setTheme] = useState(readCachedSeasonTheme);

    useEffect(() => {
        let cancelled = false;
        fetch(`${process.env.REACT_APP_PATH_TO_BACKEND}/api/season-theme`)
            .then(res => (res.ok ? res.json() : null))
            .then(data => {
                if (cancelled || !data) return;
                if (data.theme && !SEASON_THEMES[data.theme]) {
                    console.warn(`SEASON_THEME="${data.theme}" — такой темы нет, включаю кошко-девочек`);
                }
                const next = themeById(data.theme);
                try {
                    localStorage.setItem(THEME_ID_STORAGE_KEY, next.id);
                } catch {
                    // хранилище недоступно — в следующий раз просто мигнёт кошками
                }
                setTheme(next);
            })
            .catch(() => {
                // сервер недоступен — остаёмся на теме из кэша
            });
        return () => { cancelled = true; };
    }, []);

    return theme;
}

// Включена ли тема — одна настройка на все сезоны: кто сидел с кошками,
// в Хэллоуин увидит Хэллоуин, а после — снова кошек.
const STORAGE_KEY = 'seasonThemeOn';
// До сезонных тем флаг хранился так — читаем, чтобы не выключить тему тем, у кого она была.
const LEGACY_STORAGE_KEY = 'catTheme';

export function readSeasonThemeOn() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored !== null) return stored === 'true';
        return localStorage.getItem(LEGACY_STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
}

export function writeSeasonThemeOn(on) {
    try {
        localStorage.setItem(STORAGE_KEY, String(on));
    } catch {
        // приватный режим / запрет хранилища — тема просто не запомнится
    }
}
